<template>
  <div class="infor fl">
    <AllHeader
      :label="lable"
      :ischage="true"
      :img="img"
      :sublabel="sublabel"
      @getvalue="getvalue"
    />
    <div v-if="istrr">
      <el-table
        :data="list"
        :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
        style="width: 100%; margin-top: 30px"
      >
        <el-table-column
          prop="year"
          label="年度"
          min-width="50"
        ></el-table-column>
        <el-table-column
          prop="achievement.type"
          label="类型"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="填报时间"
          min-width="100"
        ></el-table-column>
        <el-table-column fixed="right" min-width="60" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="getapply(scope.row)"
              size="small"
              style="color: #194abe"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
    </div>
    <div v-if="!istrr" style="margin-top: 20px">
      <div class="achievement">
        <div class="achievementList" v-for="item in achievementList" :key="item.id">
          <div class="left">
            <p>{{ item.title }}</p>
            <p>{{ item.explain }}</p>
            <p>开始申报：{{ item.start_at }}</p>
            <p>结束申报：{{ item.end_at }}</p>
          </div>
          <div class="right blue" @click="godeclar(item.id)">业绩填报</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!istrr" style="margin-top: 20px">
      <Lineconbgtir :labelcontainer="labelcontainertow" />
      <div class="infor-c">
        业绩申报-申报须知：
        1、注册类人员包括一、二级注册建造师、注册造价师、注册监理工程师、注册安全工程师、注册会计师。（若一人有多种执业资格，只计算一次）
        2、中、高级技工指企业内从事相关工种，包括瓦工、钢筋工、混凝土工、抹灰工、防水工、管道工、水暖工、测量放线工、木工、电焊工、油漆工、安装起重工、电气设备安装调试工、工程机械维修工、中小型机械操作工等，经市级以上建筑职业技能岗位主管部门培训考核，取得中级技工及以上级别的人员。
        3、所有内容只限于调研分析所用，将会严格保密。在填写过程中有任何疑问请致电：0851-85360455；
      </div>
      <Lineconbgtir :labelcontainer="labelcontainer" />
      <Downinpu :downlist="downlist" />
      <Lineconbgtir :labelcontainer="labelcontainerone" style="margin-top: 40px" />
      <div class="upload">
        <el-upload
          class="upload-demo"
          action="http://gzjzyxh.tooge.cn/api/home/upload/file/achievement_report"
          :on-preview="handlePreview"
          :data="{token:token}"
          accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handleAdd"
          :on-error="handleError"
          list-type="text"
        >
          <div class="uploadheader">
            <span>上传文件</span>
            <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
            <span v-if="showErr" class="el-upload__tip margin-left-30" slot="tip">
              <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
            </span>
          </div>
        </el-upload>
      </div>
      <div class="redline"></div>
      <el-button
        type="primary"
        icon="el-icon-check"
        style="background-color:#194ABE"
        size="small"
        class="block-submit"
        :disabled="false"
        @click="onSubmitTap"
      >提交审核</el-button>
    </div> -->
  </div>
</template>

<script>
import AllHeader from "@/components/Modal/AllHeader";
import Pagetion from "@/components/Modal/Pagetion";
import Lineconbgtir from "@/components/Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import {
  AchievementReport, //申报列表
  AddAchievementReport, //业绩申报
  achievement,//申请业绩申报列表
} from "../utils/api.js";
export default {
  name: "performance",
  components: {
    AllHeader,
    Pagetion,
    // Lineconbgtir,
    // Downinpu,
  },
  data() {
    return {
      showErr: false,
      token: "",
      istrr: true,
      lable: "已填报的",
      fileList: [],
      total: 0,
      sublabel: "去申报",
      achievementList:[],
      downlist: [
        {
          name: "业绩申报表单",
          type: 3,
        },
      ],
      img: "../assets/apple.png",
      labelcontainer: {
        lable: "申报表单下载",
        desc: "Document download",
      },
      labelcontainerone: {
        lable: "开始上传",
        desc: "Document download",
      },
      labelcontainertow: {
        lable: "申报须知",
        desc: "Application Notes",
      },
      // tableData: [{
      // 		time: '2020',
      // 		name: '第一季度业绩报表'
      // 	},
      // 	{
      // 		time: '2020',
      // 		name: '第一季度业绩报表'
      // 	},
      // 	{
      // 		time: '2020',
      // 		name: '第一季度业绩报表'
      // 	},
      // 	{
      // 		time: '2020',
      // 		name: '第一季度业绩报表'
      // 	}
      // ],
      list: [],
      file_urls: [],
    };
  },
  mounted() {
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    this.initList(1);
    achievement().then(res => {
      console.log('res',res);
      this.achievementList = res
    })
  },
  methods: {
    godeclar(id){
      this.$router.push("/Performancedeclaration?id="+id)
    },
    initList(page) {
      const data = {
        page_size: 10,
        page: page,
      };
      AchievementReport(data).then((res) => {
        console.log("res",res);
        res.data.forEach(element => {
          element.achievement.type = element.achievement.type==1?'半年报':'年报'
        });
        this.list = res.data;
        this.total = res.total;
      });
    },
    getpageValue(index) {
      this.initList(index);
    },
    getapply(row) {
      console.log("row",row);
      // window.open(row.file_urls[0]);
      // this.$router.push(`/word_1?id=${row.id}&title=${row.achievement.explain+row.achievement.type}`)
      
      this.$router.push(`/word_1?id=${row.id}&title=${row.achievement.title}&type=achievement`)
    },
    handleAdd(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.setUrls(fileList);
      // this.fileList = fileList
      // this.ruleForm.business_license = response.data.host + response.data.url
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.setUrls(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    //获取上传数组
    setUrls(fileList) {
      let urls = [];
      fileList.map((item) => {
        urls.push(item.response.data.host + item.response.data.url);
      });
      this.file_urls = urls;
      console.log(this.file_urls);
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
      this.showErr = true;
      let that = this;
      setTimeout(function () {
        that.showErr = false;
        console.log(that.showErr);
      }, 2000);
      console.log(this.showErr);
    },
    // 提交审核
    onSubmitTap() {
      if (this.file_urls.length) {
        const data = {
          file_urls: [
            "http://gzjzyxh.tooge.cn/uploads/home/achievement_report/xls/202106/17/1623920458_cbYXNNVlSd.xls",
          ],
        };
        console.log(data);
        AddAchievementReport(data)
          .then((res) => {
            console.log(res);
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.file_urls = [];
            this.fileList = [];
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning",
        });
      }
    },
    getvalue() {
      this.istrr = !this.istrr;
      if (this.istrr) {
        this.lable = "已填报的";
        this.sublabel = "去申报";
      } else {
        this.lable = "开始业绩填报";
        this.sublabel = "返回填报记录";
      }
    },
  },
};
</script>

<style scoped lang="less">
.upload {
  margin-top: 40px;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.block-submit {
  margin-top: 36px;
  margin-bottom: 44px;
}
.achievement{
  display: flex;
  flex-wrap: wrap;
  .achievementList{
    width: 422px;
    height: 158px;
    background: #FFFFFF;
    border: 1px dashed #C8CDD5;
    opacity: 1;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding: 20px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    &:nth-child(2n){
      margin-left: 14px;
    }
    .right{
      width: 91px;
      height: 32px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 6px;
      line-height: 32px;
      cursor: pointer;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
    .gray{
      border: 1px solid #D4DBDD;
      color: #C8CDD5;
    }
    .blue{
      border: 1px solid #194ABE;
      color: #194ABE;
    }
    .left{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-evenly;
      p{
        &:nth-child(1){
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 29px;
          color: #0C0D0F;
        }
        &:nth-child(2){
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 26px;
          color: #194ABE;
        }
        &:nth-child(3),&:nth-child(4){
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 26px;
          color: #7C828A;
        }
      }
    }
  }
}

</style>
